// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2uCst","title":"AfterBackImages_title__3M3tw","images":"AfterBackImages_images__39yfO"};